
import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

const breakfastItems = [
  {
    name: 'كرواسون فرنسي',
    description: 'كرواسون فرنسي طازج محضر يوميًا بالزبدة الفاخرة',
    price: '15 ريال',
    image: 'https://public.readdy.ai/ai/img_res/1a44f513f05357f1fd9d55f2f0cd7095.jpg'
  },
  {
    name: 'دانش بالشوكولاتة',
    description: 'دانش طازج محشو بالشوكولاتة البلجيكية الفاخرة',
    price: '18 ريال',
    image: 'https://readdy.ai/api/search-image?query=Danish%20pastry%20filled%20with%20Belgian%20chocolate%20on%20elegant%20white%20plate%2C%20luxury%20bakery%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20rich%20chocolate%20glaze&width=400&height=300&seq=danish1&orientation=landscape'
  },
  {
    name: 'مافن التوت',
    description: 'مافن طازج محضر بالتوت الأزرق الطبيعي',
    price: '12 ريال',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20blueberry%20muffin%20with%20natural%20berries%20on%20elegant%20white%20plate%2C%20luxury%20bakery%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20fluffy%20texture&width=400&height=300&seq=muffin1&orientation=landscape'
  },
  {
    name: 'بيض مقلي مع الخضار',
    description: 'بيض طازج مقلي مع خضار ملونة وتوابل طبيعية',
    price: '25 ريال',
    image: 'https://readdy.ai/api/search-image?query=Fried%20eggs%20with%20colorful%20vegetables%20on%20elegant%20white%20plate%2C%20luxury%20hotel%20breakfast%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20vibrant%20healthy%20ingredients&width=400&height=300&seq=eggs1&orientation=landscape'
  },
  {
    name: 'عجة البيض بالجبن',
    description: 'عجة طازجة محضرة بالجبن الأوروبي الفاخر',
    price: '22 ريال',
    image: 'https://readdy.ai/api/search-image?query=Cheese%20omelet%20fluffy%20golden%20eggs%20on%20elegant%20white%20plate%2C%20luxury%20hotel%20breakfast%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20melted%20cheese%20center&width=400&height=300&seq=omelet1&orientation=landscape'
  },
  {
    name: 'فول مدمس',
    description: 'فول مدمس تقليدي محضر بزيت الزيتون والتوابل',
    price: '18 ريال',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20fava%20beans%20dish%20with%20olive%20oil%20herbs%20on%20elegant%20white%20plate%2C%20Middle%20Eastern%20breakfast%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20authentic%20preparation&width=400&height=300&seq=foul1&orientation=landscape'
  },
  {
    name: 'طبق أجبان مشكل',
    description: 'تشكيلة فاخرة من الأجبان المحلية والعالمية',
    price: '35 ريال',
    image: 'https://readdy.ai/api/search-image?query=Premium%20cheese%20platter%20selection%20on%20elegant%20white%20serving%20board%2C%20luxury%20hotel%20breakfast%20spread%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20variety%20of%20artisan%20cheeses&width=400&height=300&seq=cheese1&orientation=landscape'
  },
  {
    name: 'لبنة بزيت الزيتون',
    description: 'لبنة طازجة مع زيت الزيتون البكر والزعتر',
    price: '16 ريال',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20labneh%20with%20olive%20oil%20and%20herbs%20on%20elegant%20white%20plate%2C%20Middle%20Eastern%20breakfast%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20creamy%20texture%20drizzle&width=400&height=300&seq=labneh1&orientation=landscape'
  },
  {
    name: 'طبق فواكه موسمية',
    description: 'تشكيلة من الفواكه الموسمية الطازجة المقطعة',
    price: '28 ريال',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20seasonal%20fruits%20beautifully%20arranged%20on%20elegant%20white%20plate%2C%20colorful%20healthy%20breakfast%20option%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20vibrant%20natural%20presentation&width=400&height=300&seq=fruits1&orientation=landscape'
  },
  {
    name: 'عصير برتقال طازج',
    description: 'عصير برتقال طبيعي محضر طازجًا يوميًا',
    price: '15 ريال',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20orange%20juice%20in%20elegant%20clear%20glass%20with%20orange%20slices%2C%20luxury%20hotel%20breakfast%20service%2C%20professional%20beverage%20photography%20with%20clean%20simple%20white%20background%2C%20natural%20citrus%20refreshing&width=400&height=300&seq=orange1&orientation=landscape'
  },
  {
    name: 'كنافة بالجبن',
    description: 'حلوى شرقية تقليدية محضرة بالجبن والقطر',
    price: '22 ريال',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20kunafa%20dessert%20with%20cheese%20and%20syrup%20on%20elegant%20white%20plate%2C%20Middle%20Eastern%20sweets%20presentation%2C%20professional%20food%20photography%20with%20clean%20simple%20white%20background%2C%20golden%20crispy%20texture&width=400&height=300&seq=kunafa1&orientation=landscape'
  },
  {
    name: 'قهوة عربية',
    description: 'قهوة عربية أصيلة محضرة بالطريقة التقليدية',
    price: '12 ريال',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Arabic%20coffee%20in%20elegant%20small%20cup%20with%20dates%2C%20luxury%20hotel%20service%20presentation%2C%20professional%20beverage%20photography%20with%20clean%20simple%20white%20background%2C%20authentic%20cultural%20experience&width=400&height=300&seq=coffee1&orientation=landscape'
  }
];

export default function Breakfast() {
  const [scrolled, setScrolled] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar scrolled={scrolled} />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16 bg-gradient-to-r from-teal-600 to-teal-700">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Cairo, sans-serif' }}>
            المخبوزات الطازجة
          </h1>
          <p className="text-xl text-teal-100 max-w-3xl mx-auto mb-8">
            استمتع بتشكيلة واسعة من أطباق الفطور الشهية المحضرة بعناية يوميًا
          </p>
          <div className="inline-flex items-center gap-3 bg-white/20 rounded-full px-6 py-3 text-white">
            <i className="ri-time-line text-2xl"></i>
            <span className="text-lg font-semibold">يوميًا من 6:30 ص - 11:00 ص</span>
          </div>
        </div>
      </section>

      {/* Menu Items */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {breakfastItems.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="relative w-full h-48 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                
                <div className="p-6">
                  <div className="flex justify-between items-start mb-3">
                    <h3 className="text-xl font-bold text-gray-900" style={{ fontFamily: 'Cairo, sans-serif' }}>
                      {item.name}
                    </h3>
                    <span className="text-2xl font-bold text-teal-600">
                      {item.price}
                    </span>
                  </div>
                  <p className="text-base text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-16">
            <div className="inline-block bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center gap-4 justify-center mb-4">
                <i className="ri-information-line text-3xl text-teal-600"></i>
                <h3 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Cairo, sans-serif' }}>
                  معلومات إضافية
                </h3>
              </div>
              <div className="space-y-3 text-gray-700">
                <p className="text-lg"><strong>العمر:</strong> مجاني للأطفال دون 5 سنوات</p>
                <p className="text-lg"><strong>الحجز:</strong> يُنصح بالحجز المسبق للمجموعات الكبيرة</p>
                <p className="text-lg"><strong>الموقع:</strong> الطابق الأرضي - فندق فوكاتشيا</p>
                <p className="text-sm text-teal-600 font-semibold mt-4">* الأسعار للعرض فقط وقابلة للتغيير</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
